import React from 'react';

const MENU = [
  { key: 'overview', label: 'Dashboard', section: null,
    icon: 'M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25' },
  { key: 'users', label: 'Users', section: 'Management',
    icon: 'M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128H5.228A2 2 0 013.213 17.5' },
  { key: 'services', label: 'Services', section: 'Management',
    icon: 'M11.42 15.17l-5.385-2.94M11.42 15.17l5.385-2.94' },
  { key: 'products', label: 'Products', section: 'Management',
    icon: 'M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25' },
  { key: 'approvals', label: 'Approvals', section: 'Management', badge: true,
    icon: 'M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
  { key: 'locations', label: 'Locations', section: 'Management',
    icon: 'M15 10.5a3 3 0 11-6 0 3 3 0 016 0z M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z' },
  { key: 'bookings', label: 'Bookings', section: 'Commerce',
    icon: 'M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25' },
  { key: 'orders', label: 'Orders', section: 'Commerce',
    icon: 'M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007z' },
  { key: 'payments', label: 'Transactions', section: 'Commerce',
    icon: 'M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z' },
  { key: 'ads', label: 'Ad Banners', section: 'Commerce',
    icon: 'M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5' },
  { key: 'subscriptions', label: 'Subscriptions', section: 'Commerce',
    icon: 'M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z' },
  { key: 'reports', label: 'Reports', section: 'Support',
    icon: 'M3 3v1.5M3 21v-6m0 0l2.77-.693a9 9 0 016.208.682l.108.054a9 9 0 006.086.71l3.114-.732a48.524 48.524 0 01-.005-10.499l-3.11.732a9 9 0 01-6.085-.711l-.108-.054a9 9 0 00-6.208-.682L3 4.5M3 15V4.5' },
  { key: 'settings', label: 'Settings', section: 'System',
    icon: 'M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281' },
];

const AdminSidebar = ({ activeTab, onTabChange, pendingCount, collapsed, onToggle, mobileOpen, onMobileClose }) => {
  let lastSection = null;

  const handleNav = (key) => {
    onTabChange(key);
    if (onMobileClose) onMobileClose();
  };

  const renderMenu = () => MENU.map(item => {
    const showSection = item.section && item.section !== lastSection;
    if (showSection) lastSection = item.section;
    const active = activeTab === item.key;
    return (
      <React.Fragment key={item.key}>
        {showSection && !collapsed && (
          <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-[0.08em] mt-5 mb-1.5 px-3">{item.section}</p>
        )}
        {showSection && collapsed && <div className="my-2 mx-3 border-t border-gray-200" />}
        <button
          onClick={() => handleNav(item.key)}
          title={collapsed ? item.label : undefined}
          className={
            'w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-[13px] font-medium transition-all ' +
            (active
              ? 'bg-gray-900 text-white shadow-sm'
              : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900')
          }
        >
          <svg className={'flex-shrink-0 ' + (collapsed ? 'w-5 h-5' : 'w-[18px] h-[18px]')} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
          </svg>
          {!collapsed && <span className="flex-1 text-left truncate">{item.label}</span>}
          {!collapsed && item.badge && pendingCount > 0 && (
            <span className={
              'text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[20px] text-center ' +
              (active ? 'bg-white/20 text-white' : 'bg-amber-100 text-amber-700')
            }>
              {pendingCount}
            </span>
          )}
        </button>
      </React.Fragment>
    );
  });

  return (
    <>
      {/* Mobile overlay */}
      {mobileOpen && <div className="fixed inset-0 bg-black/40 z-40 lg:hidden" onClick={onMobileClose} />}

      {/* Desktop sidebar */}
      <aside className={'hidden lg:flex flex-col fixed top-0 left-0 h-screen bg-white border-r border-gray-200 z-40 transition-all duration-200 ' + (collapsed ? 'w-[60px]' : 'w-[220px]')}>
        <div className={'flex items-center h-14 border-b border-gray-100 ' + (collapsed ? 'justify-center px-2' : 'px-4 gap-3')}>
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-gray-800 to-gray-950 flex items-center justify-center text-white text-[13px] font-bold shadow-sm flex-shrink-0">T</div>
          {!collapsed && <span className="text-[15px] font-bold text-gray-900 tracking-tight">TopInfo</span>}
        </div>
        <nav className="flex-1 overflow-y-auto py-3 px-2 space-y-0.5 scrollbar-thin">
          {renderMenu()}
        </nav>
        <div className="p-2 border-t border-gray-100">
          <button onClick={onToggle}
            className="w-full flex items-center justify-center p-2 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition">
            <svg className={'w-4 h-4 transition-transform ' + (collapsed ? 'rotate-180' : '')} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5" />
            </svg>
          </button>
        </div>
      </aside>

      {/* Mobile sidebar */}
      <aside className={'lg:hidden fixed top-0 left-0 h-screen w-[260px] bg-white border-r border-gray-200 z-50 transform transition-transform duration-200 ' + (mobileOpen ? 'translate-x-0' : '-translate-x-full')}>
        <div className="flex items-center justify-between h-14 border-b border-gray-100 px-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-gray-800 to-gray-950 flex items-center justify-center text-white text-[13px] font-bold shadow-sm">T</div>
            <span className="text-[15px] font-bold text-gray-900 tracking-tight">TopInfo</span>
          </div>
          <button onClick={onMobileClose} className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-400">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        <nav className="overflow-y-auto h-[calc(100vh-56px)] py-3 px-2 space-y-0.5">{renderMenu()}</nav>
      </aside>
    </>
  );
};

export default AdminSidebar;
